const conditionCategory = {
  AMINO_ACID: 'Amino Acid Disorders',
  FATTY_ACID: 'Fatty Acid Disorders',
  ORGANIC_ACID: 'Organic Acid Disorders',
  LYSOSOMAL: 'Lysosomal Disorders',
  HEMOGLOBINOPATHY: 'Hemoglobinopathies',
  OTHER: 'Other',
};

export default conditionCategory;
